module.exports = __webpack_public_path__ + "static/media/optima-seguros-checkmark.34c9afe0.svg";